import { CreatePtMembershipByCoachDto } from '#types/member';
import { atom, useRecoilState } from 'recoil';

interface DashboardMembership extends CreatePtMembershipByCoachDto {
  discount: {
    value: number | string | null;
    unit: 'percent' | 'won';
  } | null;
}

const $dashboardCustomerMembershipState = atom<DashboardMembership>({
  key: '$dashboardCustomerMembershipState',
  default: {
    lectureId: '',
    sessionDuration: 0,
    round: 0,
    totalRound: 1000,
    price: 0,
    isRequestPayment: false,
    startedDate: '',
    expiryPeriod: '',
    expiryDate: '',
    discount: null
  }
});

export const useDashboardCustomerMembershipState = () => {
  const [
    dashboardCustomerMembershipState,
    setDashboardCustomerMembershipState
  ] = useRecoilState($dashboardCustomerMembershipState);
  return {
    dashboardCustomerMembershipState,
    setDashboardCustomerMembershipState
  };
};
